import { useState } from "react";
import {
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

import Transactions from "./analytics/Transactions/Transactions";
import Employers from "./analytics/Employe/Employers";
import PDFDownload from "./Download/PDFdownload";
import XLDownload from "./Download/XLdownload";

import style from "./Dashboard.module.css";
import Loader from "../../loader/loader"; // (still imported but not needed now)

const Dashboard = () => {
  const [activePage, setActivePage] = useState("transactions");
  const [drawerOpen, setDrawerOpen] = useState(true);
  const navigate = useNavigate();

  return (
    <>
      <div className={style.pageContent}>
        <div className={style.container}>
          {/* Toggle Icon for opening drawer */}
          <div className={style.drawerToggle}>
            {!drawerOpen && (
              <IconButton onClick={() => setDrawerOpen(true)}>
                <MenuIcon />
              </IconButton>
            )}
          </div>

          {/* Drawer */}
          {drawerOpen && (
            <div className={style.customDrawer}>
              <div className={style.drawerHeader}>
                <Typography variant="h6">Analytics</Typography>
                <IconButton onClick={() => setDrawerOpen(false)}>
                  <CloseIcon />
                </IconButton>
              </div>

              <List>
                <ListItem
                  button
                  selected={activePage === "transactions"}
                  onClick={() => setActivePage("transactions")}
                >
                  <ListItemText primary="Transactions" />
                </ListItem>
                <ListItem
                  button
                  selected={activePage === "employers"}
                  onClick={() => setActivePage("employers")}
                >
                  <ListItemText primary="Employee" />
                </ListItem>
              </List>

              <Divider sx={{ margin: "10px 0" }} />

              <Typography variant="h6" sx={{ padding: "10px 0" }}>
                Download
              </Typography>
              <List>
                <ListItem
                  button
                  selected={activePage === "xlDownload"}
                  onClick={() => setActivePage("xlDownload")}
                >
                  <ListItemText primary="XL Download" />
                </ListItem>
                <ListItem
                  button
                  selected={activePage === "pdfDownload"}
                  onClick={() => setActivePage("pdfDownload")}
                >
                  <ListItemText primary="PDF Download" />
                </ListItem>
              </List>
            </div>
          )}

          {/* Main Content */}
          <div
            className={`${style.mainContent} ${
              !drawerOpen ? style.mainContentShifted : ""
            }`}
          >
            <div className={style.content}>
              {activePage === "transactions" && <Transactions />}
              {activePage === "employers" && <Employers />}
              {activePage === "xlDownload" && <XLDownload />}
              {activePage === "pdfDownload" && <PDFDownload />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
